/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { SKELETON_BLOCK, skeletonSlots } from './skeleton-primitives';

export interface TableRowsSkeletonProps {
  /** Number of table-row placeholders to render. */
  rows?: number;
}

/**
 * Placeholder mimicking rows of a data table.
 *
 * @param props Number of rows to render.
 * @returns A shimmering table-rows placeholder.
 */
export const TableRowsSkeleton: React.FC<TableRowsSkeletonProps> = ({
  rows = 6,
}) => (
  <div data-testid="table-rows-skeleton" className="flex flex-col gap-2">
    {skeletonSlots(rows).map((slot) => (
      <div
        key={slot}
        data-testid="table-rows-skeleton-row"
        className="flex items-center gap-4 rounded-(--radius-md) border border-[var(--border-subtle)] bg-[var(--surface-primary)] px-4 py-3"
      >
        <div className={`${SKELETON_BLOCK} h-4 w-1/4`} />
        <div className={`${SKELETON_BLOCK} h-4 flex-1`} />
        <div className={`${SKELETON_BLOCK} h-4 w-16`} />
      </div>
    ))}
  </div>
);
